import { render, staticRenderFns } from "./IngredientsEditor.vue?vue&type=template&id=92e8d69e&scoped=true&"
import script from "./IngredientsEditor.vue?vue&type=script&lang=js&"
export * from "./IngredientsEditor.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsEditor.vue?vue&type=style&index=0&id=92e8d69e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e8d69e",
  null
  
)

export default component.exports